import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  TextField,
  Button
} from '@mui/material';
import DialogReporte from '../../usuarios/envios/reporte/DialogReporte';
import { FiltradorInput } from '../../../atomos/FiltradorInput';
import ReporteExcelButton from '../../../atomos/ReporteExcelButton';
import FiltroFechas from '../../../atomos/FiltroFechas';
import PedirReporteEmpaqueButton from '../../../atomos/PedirReporteEmpaqueButton';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

ProductListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function ProductListToolbar({
  numSelected,
  filterName,
  onFilterName,
  hasFilterDate = false,
  hasReporte = false,
  hasFiltrador = false,
  onDesdeDate,
  onHastaDate,
  hasReporteExcel = false,
  reporteData,
  usersIdList,
  intervaloReporte,
  userIds,
  placeholder,
  width = {}
}) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? 'primary.lighter' : 'primary.dark'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <>
          {hasFiltrador ? (
            <FiltradorInput
              setSearchTerm={onFilterName}
              searchTerm={filterName}
              labelText="Filtrar por nombre o productos"
            />
          ) : (
            <SearchStyle
              {...width}
              value={filterName}
              onChange={onFilterName}
              placeholder={placeholder !== undefined ? placeholder : 'Search product...'}
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              }
            />
          )}

          {hasFilterDate && (
            // <FiltroFechas />
            <Box sx={{ display: 'flex', gap: '10px' }}>
              <TextField
                type="date"
                label="Desde"
                onChange={onDesdeDate}
                InputLabelProps={{
                  shrink: true
                }}
              />

              <TextField
                type="date"
                label="Hasta"
                onChange={onHastaDate}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Box>
          )}
          {/* {hasReporte && <DialogReporte />} */}
          {hasReporte && <PedirReporteEmpaqueButton intervaloReporte={intervaloReporte} userIds={userIds} />}
          {hasReporteExcel && !hasReporte && <ReporteExcelButton dataList={reporteData} usersIdList={usersIdList} />}
        </>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      )}
    </RootStyle>
  );
}
